/**
 * Project : workspace
 * File    : SubCategoryDetailScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.inventory.sub_category.detail

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Button
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.commerce.feature.cart.viewModel.CartViewModel
import com.parmartechnologies.commerce.feature.inventory.product.viewModel.ProductViewModel
import com.parmartechnologies.core.navigation.NavigationParam
import component.navigation.TopNavBar
import component.product.ProductCard
import locale.localization
import navigation.AppNavigator
import navigation.route.inventory.InventoryNavRoute
import theme.ThemeColor

/**
 * Represents the sub category detail screen class.
 */

class SubCategoryDetailScreen{
    @Composable
    fun Content() {
        val businessViewModel = BusinessViewModel()
        val myBusiness = businessViewModel.myBusiness.collectAsState()
        val productViewModel = ProductViewModel(myBusiness.value)
        val allProducts = productViewModel.allProduct.collectAsState()
        val cartViewModel = CartViewModel(myBusiness.value)
        val navigationParam = AppNavigator.shared().getNavigationParam()
        LaunchedEffect(key1 = Unit) {
            productViewModel.loadProductForSubCategory(
                navigationParam.business._id,
                navigationParam.productSubCategory._id
            )
        }
        Column(
            modifier = Modifier.fillMaxSize()
                .background(ThemeColor.shared().defaultBakground)
        ) {
            TopNavBar(
                title = localization().subCategory.subCategoryTitle,
                NavigationParam(),
                onBackPress = {
                    AppNavigator.shared().goBack()
                },
                onClickAdd = {
                    AppNavigator.shared().navigate(InventoryNavRoute.ProductCategory.CREATE)
                })
//            AppLoader(viewModel)
            Row(
                modifier = Modifier
                    .padding(8.dp, 4.dp)
                    .fillMaxWidth()
                    .height(56.dp)
                    .background(
                        ThemeColor.shared().cardBackground,
                        shape = RoundedCornerShape(8.dp)
                    ),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    navigationParam?.productSubCategory?.Name ?: "", fontSize = 20.sp,
                    modifier = Modifier.fillMaxWidth().padding(start = 8.dp).wrapContentHeight()
                        .weight(0.7f)
                )
                Box(
                    modifier = Modifier.fillMaxWidth().fillMaxHeight().weight(0.25f)
                        .padding(top = 8.dp, bottom = 8.dp)
                ) {
                    Button(onClick = {
                        AppNavigator.shared().navigate(InventoryNavRoute.ProductSubCategory.UPDATE,navigationParam)
                    }) {
                        Text(
                            "Edit", fontSize = 20.sp,
                            modifier = Modifier.fillMaxWidth().padding(start = 8.dp)
                                .wrapContentHeight().weight(0.7f)
                        )
                    }
                }

            }
            LazyVerticalGrid(
                columns = GridCells.Adaptive(minSize = 180.dp),
                modifier = Modifier.fillMaxSize().padding(bottom = 60.dp)
            ) {
                items(allProducts.value.count()) { index ->
                    ProductCard(allProducts.value[index], cartViewModel, navigationParam) {

                    }.content()
                }
            }
        }
    }
}